<template>
  <mc-exercise-frame>
    <div class="mc-layout-gfx3d-container">
      <div
        class
        style="position:absolute; top: 0; height: 50%; width: 100%; overflow-y: scroll; border-bottom: 1px solid lightgray; "
      >
        <ul style="color: red; position: fixed; z-index: 999;" class="e2e-gfx3d-error-logs">
          <li
            v-for="error in gfx3dErrors"
            :key="error.message"
          >[Line: {{error.line}}] {{error.message}}</li>
        </ul>

        <geogebra-wrapper
          v-if="layoutReady"
          style="margin: auto;"
          ref="mainGfx3dBoard"
          :width="boardWidth"
          :height="boardHeight"
          @onGfx3dApiReady="onGfx3dApiReady"
        />
      </div>
      <div style="position:absolute; top: 50%; width: 100%; height: 50%; overflow-y: scroll; ">
        <div class="mc-container">
          <output-frames :output-frames="outputFrames"></output-frames>
        </div>
      </div>
    </div>
  </mc-exercise-frame>
</template>

<script>
import Logger from "../../shared/logger";
const LOGGER = new Logger(__filename);

import McExerciseFrame from "../base/mc-exercise-frame.vue";
import OutputFrames from "../base/output/output-frames.vue";

import GeogebraWrapper from "../base/output/gfx3d/geogebra-wrapper.vue";
import {
  updateForms,
  onDoModification,
  updateData,
  doModification
} from "../base/output/gfx3d/gfx3d";

export default {
  components: {
    GeogebraWrapper,
    McExerciseFrame,
    OutputFrames
  },
  data() {
    return {
      gfx3dErrors: []
    };
  },
  computed: {
    outputFrames() {
      return this.$store.state.outputFrames;
    },
    boardWidth() {
      if (this.layoutReady) {
        let config = this.$store.state.layout.config;
        return config ? parseInt(config.width) : null;
      }
      return null;
    },
    boardHeight() {
      if (this.layoutReady) {
        let config = this.$store.state.layout.config;
        return config ? parseInt(config.height) : null;
      }
      return null;
    },
    layoutReady() {
      let layout = this.$store.state.layout;
      return layout !== null && layout !== undefined;
    }
  },
  methods: {
    onGfx3dApiReady(api) {
      LOGGER.log("onGfx3dApiReady");
      const that = this;

      // Änderungen verfolgen
      api.addChangedListener(data => {
        LOGGER.log("onBoardChanged");
        updateData(data); // Board-Zustand ins Datenmodell übertragen
        updateForms(); // Datenmodell an Feedback-Formulare übertragen
      });

      // Fehler verfolgen
      api.addErrorListener(gfx3dError => {
        that.gfx3dErrors.push(gfx3dError);
      });

      // Modifikationen an das **einzige** interaktionsfähige Geogebra-Board weiterleiten
      onDoModification(async function(modification) {
        LOGGER.log("onDoModification", modification);
        let { script, base64 } = modification;
        if (base64) {
          await api.loadBase64(base64);
        }
        if (script) {
          await api.runScript(script);
        }
      });
      // initiale modifikationen (gemäß layout) durchführen
      doModification({
        script: that.$store.state.layout.config.script,
        base64: that.$store.state.layout.config._base64
      });
    }
  }
};
</script>
 

<style scoped>
.mc-layout-gfx3d-container {
  position: absolute;
  overflow-y: auto;
  overflow-x: hidden;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

@media (min-width: 900px) {
  .mc-container {
    max-width: 1000px;
    margin: auto;
  }
}
@media (max-width: 900px) {
  .mc-container {
    min-width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
</style>